module.exports = __webpack_public_path__ + "img/ban.d1ec4d42.svg";